let getAccessTokenSilently: (() => Promise<string> | null) | null = null;

interface TokenManager {
	getAccessTokenSilently: () => (() => Promise<string> | null) | null;
	setAccessTokenSilently: (func: () => Promise<string>) => void;
}

const tokenManager: TokenManager = {
	getAccessTokenSilently: () => getAccessTokenSilently,
	setAccessTokenSilently: (func: () => Promise<string>) => {
		getAccessTokenSilently = func;
	},
};

export default tokenManager;
